import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import { Button, Create, NumberInput, required, SelectArrayInput, TextInput, Toolbar, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { Separator } from "../../Components/Separator";
import { useAppDataProvider } from "../../dataprovider";
import { CoreInfoRequestReasonType } from "../../Constants/Constant";
import { CoreInfoRequestReasonTypeEnum } from "../../../src/Enums/CoreInfoRequestReasonTypeEnum";
import { CoreInfoRequestPostModel } from "./Model/CoreInfoRequestModel";
import { CoreInfoRequestDetailCreate } from "./Model/CoreInfoRequestDetailModel";
import { CoreInfoRequestStatusEnum } from "../../../src/Enums/CoreInfoRequestStatusEnum";
import { HourMinuteInput } from "../../../src/Components/HourMinuteInput";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const CoreInfoRequestCreate = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [coreInfoRequestData, setCoreInfoRequest] = useState({} as any);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const handleBlur = form => e => {
    const refNo = form?.getState?.()?.values?.refNo;
    if (refNo != null && refNo != undefined && refNo != "") {
      dataProvider
        .getCoreInfoRequestByRefNo(refNo)
        .then(response => {
          if (response.data != null) {
            setCoreInfoRequest(response.data);
            form.change("customer", response.data.customer);
            form.change("customerPo", response.data.customerPo);
            form.change("pn", response.data.pn);
            form.change("sn", response.data.sn);
            form.change("tso", response.data.tso);
            form.change("tsn", response.data.tsn);
            form.change("tsr", response.data.tsr);
            form.change("cso", response.data.cso);
            form.change("csn", response.data.csn);
            form.change("csr", response.data.csr);
            form.change("dso", response.data.dso);
            form.change("dsn", response.data.dsn);
            form.change("dsr", response.data.dsr);
            form.change("adSbMod", response.data.adSbMod);
            form.change("removalReasonDetail", response.data.removalReasonDetail);
            form.change("nha", response.data.nha);
            form.change("nla", response.data.nla);
            form.change("dom", response.data.dom);
            form.change("tsi", response.data.tsi);
            form.change("csi", response.data.csi);
            form.change("dsi", response.data.dsi);
          }
        })
        .catch(error => {});
    }
  };

  const CreateCoreInfoRequestButtonClick = e => {
    CreateCoreInfoRequest(e);
  };

  const CreateCoreInfoRequest = async e => {
    let coreInfoRequestModel: CoreInfoRequestPostModel = new CoreInfoRequestPostModel();
    let requestReasonListCreate = [] as CoreInfoRequestDetailCreate[];
    var requestedFields = "";

    if (e.coreInfoRequestReasons !== undefined) {
      e.coreInfoRequestReasons.forEach(reason => {
        let coreInfoRequestDetailModel: CoreInfoRequestDetailCreate = new CoreInfoRequestDetailCreate();
        coreInfoRequestDetailModel.CoreInfoRequestReasonId = reason;
        requestedFields = requestedFields.concat(CoreInfoRequestReasonTypeEnum[reason] + ";");
        requestReasonListCreate.push(coreInfoRequestDetailModel);
      });
    }

    coreInfoRequestModel.RequestId = coreInfoRequestData.id;
    coreInfoRequestModel.CoreInfoRequestDetails = requestReasonListCreate;
    coreInfoRequestModel.RequestedFields = requestedFields;
    coreInfoRequestModel.Status = CoreInfoRequestStatusEnum.WaitingCustomer;

    dataProvider
      .postCoreInfoRequest(coreInfoRequestModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        history.push("/coreinforequests");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={CreateCoreInfoRequestButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props} title={"Create Core Info Request"}>
                <>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="refNo"
                        label="Ref No"
                        fullWidth
                        validate={required()}
                        variant="outlined"
                        onBlur={handleBlur(form)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <SelectArrayInput
                        source="coreInfoRequestReasons"
                        choices={CoreInfoRequestReasonType}
                        optionText="reasonType"
                        optionValue="value"
                        validate={required()}
                        variant="outlined"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="customer" label="CUSTOMER" fullWidth variant="outlined" disabled />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="customerPo" label="CUSTOMER PO" fullWidth variant="outlined" disabled />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="pn" label="PN" fullWidth variant="outlined" disabled />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="sn" label="SN" variant="outlined" fullWidth disabled />
                    </Grid>
                    <Grid item xs={12} sm={5} />
                  </Grid>

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="dom" label="DOM" fullWidth variant="outlined" disabled />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="removalReasonDetail"
                        label="Removal Reason Detail"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  </Grid>

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="nha" label="NHA" fullWidth variant="outlined" disabled />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="nla" label="NLA" fullWidth variant="outlined" disabled />
                    </Grid>
                  </Grid>

                  <Grid {...gridContainerProps} justifyContent="space-around" alignItems="center">
                    <Grid container spacing={1} sm={5}>
                      <Grid item xs>
                        <HourMinuteInput
                          hourDigits={7}
                          source="tsi"
                          label="TSI (Hour)"
                          fullWidth
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item xs>
                        <HourMinuteInput
                          hourDigits={7}
                          source="tso"
                          label="TSO (Hour)"
                          fullWidth
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item xs>
                        <HourMinuteInput
                          hourDigits={7}
                          source="tsr"
                          label="TSR (Hour)"
                          fullWidth
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item xs>
                        <HourMinuteInput
                          hourDigits={7}
                          source="tsn"
                          label="TSN (Hour)"
                          fullWidth
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="adSbMod" label="AD(SB/MOD)" fullWidth disabled variant="outlined" />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid container spacing={1} sm={5}>
                      <Grid item xs>
                        <NumberInput source="csi" label="CSI (Cycle)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="cso" label="CSO (Cycle)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="csr" label="CSR (Cycle)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="csn" label="CSN (Cycle)" fullWidth variant="outlined" disabled />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} sm={5}></Grid>
                  </Grid>

                  <Grid {...gridContainerProps}>
                    <Grid container spacing={1} sm={5}>
                      <Grid item xs>
                        <NumberInput source="dsi" label="DSI (Days)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="dsr" label="DSR (Days)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="dsn" label="DSN (Days)" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs>
                        <NumberInput source="dso" label="DSO (Days)" fullWidth variant="outlined" disabled />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} sm={5}></Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Core Info Request is creating!" : "Core Info Request"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default CoreInfoRequestCreate;
